import React from 'react';
import { Text, Message, ButtonLink, Link } from '@lucidhq/lucidium';
import { useAuth } from './hooks';
export var DefaultAuthorizationError = function () {
    var auth = useAuth();
    return (React.createElement(Message, { message: "Unauthorized", description: "You are not authorized to view this page.", helper: React.createElement(Text, { lss: { textScale: 'caption' } },
            "If you need access, please",
            ' ',
            React.createElement(Link, { to: "https://support.lucidhq.com/s/", target: "_blank" }, "contact"),
            ' ',
            "our support team."), actions: [
            React.createElement(ButtonLink, { to: "/", palette: "primary", key: "back-to-home" }, "Back to Home"),
            React.createElement(ButtonLink, { onClick: auth.logout, palette: "primary", emphasis: "medium", key: "logout" }, "Logout")
        ] }));
};
//# sourceMappingURL=DefaultAuthorizationError.js.map